// @flow
import { type Source } from '@ta/media.image';

type GqlImage = ?$ReadOnly<{
  +photoSizes: ?$ReadOnlyArray<?{|
    +width: ?number,
    +height: ?number,
    +url: ?string,
  |}>,
}>;

/**
 * @param sources - optional image sources from GraphQL
 * @return image sources shaped like the @ta/media.image package uses, or null if there is no
 * supplied image
 */
const getImageSources = (gqlImage: GqlImage): ?(Source[]) => {
  const imageSources = [];

  if (gqlImage != null && gqlImage.photoSizes != null) {
    gqlImage.photoSizes.forEach(source => {
      if (source != null && source.width != null && source.height != null && source.url != null) {
        imageSources.push({
          width: source.width,
          height: source.height,
          url: source.url,
        });
      }
    });
  }

  if (imageSources.length > 0) {
    return imageSources;
  }

  return null;
};

export default getImageSources;
